module.exports = __webpack_public_path__ + "static/img/product-sweaters.d23d1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sales-overview/product-sweaters.jpg
// module id = /8cB
// module chunks = 3